import * as React from 'react';
import { useSelector } from 'react-redux';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';
import { useApplicationContext } from 'shared/utils/applicationContext';

import { SLIDES_CONFIG_KEY, SLIDES_DEFAULT, TCompareFlightSlides } from './constants';
import { SliderModalLoadable } from './loadable';
import { trackCompareFlightModalClose, trackCompareFlightModalScroll, trackCompareFlightModalShow } from './tracking';

export interface INewbuildingCompareFlightModalContainerProps {
  onClose(): void;
}

export const NewbuildingCompareFlightModalContainer: React.FC<INewbuildingCompareFlightModalContainerProps> = ({
  onClose,
}) => {
  const { config } = useApplicationContext();
  const jsonQuery = useSelector(getJsonQuery);

  /* istanbul ignore next */
  const slides = config.get<TCompareFlightSlides>(SLIDES_CONFIG_KEY) ?? SLIDES_DEFAULT;

  // Контейнер монтируется только при открытии модалки, поэтому показ трекаем на маунт
  React.useEffect(() => {
    trackCompareFlightModalShow(jsonQuery);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSlideChange = React.useCallback(
    (pageNumber: number) => {
      trackCompareFlightModalScroll(jsonQuery, pageNumber);
    },
    [jsonQuery],
  );

  const handleClose = React.useCallback(() => {
    trackCompareFlightModalClose(jsonQuery);
    onClose();
  }, [jsonQuery, onClose]);

  return <SliderModalLoadable slides={slides} onClose={handleClose} onSlideChange={handleSlideChange} />;
};
